import { DesignProp } from "../PropCategories";

export const padding = {
  prop: "style-attribute",
  name: "Padding",
  nameI18n: "builder_ui.prop_type.styles.padding",
  defaultValue: {
    paddingTop: "10",
    paddingBottom: "10",
    paddingLeft: "10",
    paddingRight: "10",
  },
  category: [DesignProp],
  type: "box-model",
  boxModelType: "padding",
} as const;
